<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<div *ngIf="!loading">

  <!-- Header -->
  <div class="gl-header mb-4">
    <a class="gl-back-btn" [routerLink]="['/', langSrcSrv.current.shortCode, 'themes']">
      <i class="fa-solid fa-arrow-left"></i>
      <span translate>Thématiques</span>
    </a>
    <div class="gl-header-center">
      <h2 class="gl-section-title">{{ data.theme.translation }}</h2>
    </div>
    <div class="gl-header-spacer"></div>
  </div>

  <!-- Levels grid -->
  <div class="row">
    <div class="col-12 col-md-6 col-lg-4 mb-4" *ngFor="let level of data.levels; trackBy: trackById">
      <div
        class="gl-card gl-level-card h-100"
        [class.gl-level-locked]="level.locked"
        [class.gl-level-premium]="themePremiumLocked"
        (click)="navigateToLevel(level)">

        <!-- Overlay verrou standard (API) -->
        <div class="gl-lock-overlay" *ngIf="level.locked">
          <i class="fa-solid fa-lock"></i>
        </div>

        <!-- Overlay premium -->
        <div class="gl-premium-overlay" *ngIf="themePremiumLocked">
          <div class="gl-premium-overlay-inner">
            <i class="fa-solid fa-crown"></i>
            <span translate>Premium</span>
          </div>
        </div>

        <!-- Image -->
        <div class="gl-level-img-wrap">
          <img *ngIf="!level.image"
            src="assets/images/monuments/{{langTgtSrv.current.code}}.png"
            class="gl-level-img" alt="" />
          <img *ngIf="level.image"
            [src]="level.image | gameImage"
            class="gl-level-img" alt="" />
        </div>

        <!-- Info -->
        <div class="gl-level-info">
          <div class="gl-level-name">{{ level.name }}</div>
          <div class="gl-progress-row">
            <div class="gl-progress-track">
              <div class="gl-progress-fill" [style.width.%]="level.bestScore > 0 ? level.bestScore : 0"></div>
            </div>
            <span class="gl-progress-label">{{ level.bestScore > 0 ? level.bestScore : 0 }}%</span>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>
